import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';
import Tooltip from '@zenbusiness/zui/Tooltip';

import VeloAvatar from '#client/components/VeloAssistantButton/VeloAvatar';

import * as Styled from './PersonalizationIndicator.styles';

export function PersonalizationIndicator({ personalizationStatus, showPersonalizationComplete }) {
  const isLoading = personalizationStatus === 'in_flight';
  const isComplete = personalizationStatus === 'applied' && showPersonalizationComplete;

  if (!isLoading && !isComplete) {
    return null;
  }

  const labelId = isLoading
    ? 'productPage.personalization.indicator.loading'
    : 'productPage.personalization.indicator.complete';
  const tooltipId = isLoading
    ? 'productPage.personalization.indicator.loading.tooltip'
    : 'productPage.personalization.indicator.complete.tooltip';

  return (
    <Styled.IndicatorContainer direction="row" gap={1}>
      <Tooltip title={<FormattedMessage id={tooltipId} />}>
        <div>
          <VeloAvatar state={isLoading ? 'processing' : 'default'} width={20} height={20} />
        </div>
      </Tooltip>
      <Text size="sm" color="secondary">
        <FormattedMessage id={labelId} />
      </Text>
    </Styled.IndicatorContainer>
  );
}

PersonalizationIndicator.propTypes = {
  personalizationStatus: PropTypes.oneOf(['disabled', 'in_flight', 'applied', 'fallback']).isRequired,
  showPersonalizationComplete: PropTypes.bool.isRequired
};
